'use client';

import styled from 'styled-components';

import type { RelatedProductRenderer } from '@zoomit/editor';
import { Flex } from '@zoomit/primitives';
import type {
  ProductListItemType} from '@zoomit/web-kit';
import {
  isMobile,
  ProductListItemDesktop,
  ProductListItemMobile
} from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { useProductPriceQuery } from '../../../hooks/useProductPrice';

type Props = {
  blockData: RelatedProductRenderer;
};

const RelatedProductList = (props: Props) => {
  const { blockData } = props;
  const productsIds = blockData.products.map((e) => e.id);

  const { productQuery, findPrice } = useProductPriceQuery({ productsIds });
  const { data: prices, isLoading } = productQuery;

  return (
    <Flex flexDirection="column" spacing={{ px: 'x' }}>
      <Title variant="h5" className="fa" spacing={{ mb: 'x6' }}>
        {blockData.title}
      </Title>
      <Flex flexDirection="column" gap={0.8}>
        {blockData.products.map((data) =>
          isMobile ? (
            <ProductListItemMobile
              {...(data as ProductListItemType)}
              minPrice={+findPrice(data.id, prices)}
              isLoadingPrice={isLoading}
            />
          ) : (
            <ProductListItemDesktop
              key={data.id}
              {...(data as ProductListItemType)}
              size="large"
              minPrice={+findPrice(data.id, prices)}
              isLoadingPrice={isLoading}
            />
          ),
        )}
      </Flex>
    </Flex>
  );
};

export default RelatedProductList;

const Title = styled(Typography)`
  position: relative;
  padding-right: 1.6rem;

  &::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 2.4rem;
    top: 0;
    right: 0;
    background-color: ${cssVar(theme.primary1)};
  }
`;
